import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/account/profile')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
